import { Ref, SetupContext, WritableComputedRef } from 'vue';
import {
  FieldHtmlNameUtil,
  HekateDisplayField,
  HekateDisplayForm,
} from 'www-shared';
import FieldUtil from '../fields/FieldUtil';

export default class CheckboxFieldCoordinator {
  protected field: Ref<HekateDisplayField>;

  protected modelValue: Ref<boolean>;

  protected context: SetupContext;

  protected formDefinition: Ref<HekateDisplayForm | null>;

  constructor({
    field,
    modelValue,
    context,
    formDefinition,
  }: {
    field: Ref<HekateDisplayField>
    modelValue: Ref<boolean>,
    context: SetupContext,
    formDefinition: Ref<HekateDisplayForm | null>,
  }) {
    this.field = field;
    this.modelValue = modelValue;
    this.context = context;
    this.formDefinition = formDefinition;
  }

  /** Return a boolean bubble model */
  public buildBubbleModel(): WritableComputedRef<boolean> {
    const bubbleModel = FieldUtil.bubbleModel({
      get: () => `${this.modelValue.value}` === 'true',
      emitter: this.context,
    }) as WritableComputedRef<boolean>;
    return bubbleModel;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  public setup() {
    const clickToLateBlur = FieldUtil.lateBlur({
      field: this.field,
      emitter: this.context,
    });

    const setInteractiveState = () => {
      FieldUtil.setInteractiveState({
        field: this.field,
        newState: 'dirty',
      });
    };

    const smallTextFields = [
      FieldHtmlNameUtil.privacyConsentAccepted,
      FieldHtmlNameUtil.isAgreeToTermsOfService,
      FieldHtmlNameUtil.tosConsentAccepted,
    ] as Array<string>;
    const isSmallText = smallTextFields.includes(this.field.value.htmlName);
    const isPrivacyPolicy = this.field.value.htmlName === FieldHtmlNameUtil.privacyConsentAccepted;
    const isTermsOfService = this.field.value.htmlName === FieldHtmlNameUtil.isAgreeToTermsOfService;

    return {
      bubbleModel: this.buildBubbleModel(),
      isPrivacyPolicy,
      isTermsOfService,
      isSmallText,
      clickToLateBlur,
      setInteractiveState,
    };
  }
}
